module.exports = require("@swa-ui/dotcom/src/DotcomFooter/DotcomDesktopFooter/Callouts/Callouts.module.scss");